import Axios from 'axios';

const BASE_URL = process.env.REACT_APP_SERVER_URL;

export const axiosInstance = Axios.create({
  withCredentials: true,
  baseURL: BASE_URL,
});

// Add a request interceptor
axiosInstance.interceptors.request.use((config) => {
  const sep = config.url?.includes('?') ? '&' : '?';
  // eslint-disable-next-line no-restricted-globals,no-param-reassign
  config.url += location.search.replace('?', sep);
  return config;
}, (error) => Promise.reject(error));

export const axiosUnauth = Axios.create({
  transformRequest: [
    (data, headers) => {
      // @ts-ignore
      // eslint-disable-next-line no-param-reassign
      delete headers?.common?.Authorization;
      return data;
    },
  ],
});
